import * as Actions from "./actions";
import * as Mutations from "./mutations";
import { getWithExpiry } from "@/store/utils/localStorageUtil"
const key = "CartoConfig"
const cartoConfig = getWithExpiry(key)

const auth = {
    namespaced: true,
    state: {
        mapscloudUser: null,
        cartoConfig,
        loginError: null,
        cartoConfigError: null,
        cartoUserCreationState: null

    },
    getters: {
    },
    actions: {
        loginByUsername: Actions.loginByUsername,
        loginByMobile: Actions.loginByMobile,
        loginBySocial: Actions.loginBySocial,
        loginCartodb: Actions.loginCartodb,
        getCartdbConfig: Actions.getCartdbConfig,
        getUserJWT: Actions.getUserJWT,
        checkUserCreation: Actions.checkUserCreation,
        logout: Actions.logout,
        getCartodbConfig: Actions.getCartodbConfig,
        getCartoSessionConfig: Actions.getCartoSessionConfig,
    },
    mutations: {
        setMapscloudUser: Mutations.setMapscloudUser,
        setCartoConfig: Mutations.setCartoConfig,
        setLoginError: Mutations.setLoginError,
        setCartoConfigError: Mutations.setCartoConfigError,
        setCartoUserCreateionState: Mutations.setCartoUserCreateionState
    },
};
export default auth;
